export const projects = [
    {
        name: "Website Portfolio",
        image: <img src={require('./ProjectPics/jasontedjo.png')} alt="Website Portfolio Image" className="projectPic"></img>,
        description: 
            <div className='description'>
                My own personal portfolio, created using <span className="highlight">React</span>. I hope for this to be a place where I can showcase my projects and interest, as well as my work history and experience. Stay tune for more updates!
            </div>,
        skills: [
            <a key={'react'} className='listItem' href="https://react.dev/" target="_blank" rel="noopener noreferrer">React</a>
        ],
        links: [
            <a key={'jasontedjo.com'} className='listItem' href="https://jasontedjo.com" target="_blank" rel="noopener noreferrer">jasontedjo.com</a>
        ]
    },
    {
        name: "CodeHunt",
        image: <img src={require('./ProjectPics/codehunt.png')} alt="CodeHunt Image" className="projectPic"></img>,
        description: 
            <div className='description'>
                CodeHunt is made to help Codeforces and UVa Online Judge users filter their problems with convenience and ease. You can also compare yourself with friends and rivals to motivate your practice and growth.
            </div>,
        skills: [
            <a key={'angular'} className='listItem' href="https://angular.io/" target="_blank" rel="noopener noreferrer">Angular</a>
        ],
        links: [
            <a key={'codehunt.cc'} className='listItem' href="https://codehunt.cc" target="_blank" rel="noopener noreferrer">codehunt.cc</a>,
            <a key={'codeforces'} className='listItem' href="https://codeforces.com/blog/entry/81053" target="_blank" rel="noopener noreferrer">Codeforces Blog</a>
        ]
    },
    {
        name: "GoalTrek",
        image: <img src={require('./ProjectPics/goaltrek.png')} alt="GoalTrek App Interface" className="projectPic"></img>,
        description: 
            <div className='description'>
                GoalTrek is a privacy-focused, offline <span className="highlight">React Native</span> productivity application designed to help users track complex goals and manage tasks without ads or cloud synchronization. It enables breaking down goals into sub-goals and records progress logs locally on the device.
            </div>,
        skills: [
            <a key={'react-native'} className='listItem' href="https://reactnative.dev/" target="_blank" rel="noopener noreferrer">React Native</a>,
            <a key={'typescript'} className='listItem' href="https://www.typescriptlang.org/" target="_blank" rel="noopener noreferrer">TypeScript</a>,
            <a key={'asyncstorage'} className='listItem' href="https://react-native-async-storage.github.io/async-storage/" target="_blank" rel="noopener noreferrer">AsyncStorage</a>
        ],
        links: [
            <a key={'goaltrek-playstore'} className='listItem' href="https://play.google.com/store/apps/details?id=com.goaltrek" target="_blank" rel="noopener noreferrer">Google Play Store</a>,
            <a key={'goaltrek-appstore'} className='listItem' href="https://apps.apple.com/us/app/goaltrek-journal/id6651822586" target="_blank" rel="noopener noreferrer">App Store</a>
        ]
    },
    {
        name: "BBagi",
        image: <img src={require('./ProjectPics/bbagi.png')} alt="BBagi App Contributions" className="projectPic"></img>,
        description: 
            <div className='description'>
                BBagi is a reflective investing application built with <span className="highlight">React Native</span> for young adults to build intentional trading habits. The app empowers users to capture the reasoning behind every trade, review decision patterns over time, and learn in a trusted social environment.
            </div>,
        skills: [
            <a key={'react-native'} className='listItem' href="https://reactnative.dev/" target="_blank" rel="noopener noreferrer">React Native</a>,
            <a key={'typescript'} className='listItem' href="https://www.typescriptlang.org/" target="_blank" rel="noopener noreferrer">TypeScript</a>,
            <a key={'aws'} className='listItem' href="https://aws.amazon.com/" target="_blank" rel="noopener noreferrer">AWS Stack</a>,
            <span key={'finance-api'} className='listItem'>Stock/Finance APIs</span>
        ],
        links: [
            <a key={'bbagi-website'} className='listItem' href="https://bbagi.app" target="_blank" rel="noopener noreferrer">bbagi.app</a>,
            <a key={'bbagi-playstore'} className='listItem' href="https://play.google.com/store/apps/details?id=com.bbagiapp" target="_blank" rel="noopener noreferrer">Google Play Store</a>
        ]
    }
]